export default __webpack_public_path__ + "static/awards-image-ba615342eb3c4b6ce0bef1c7243ba19f.png";